import { styled } from "goober";
import { config } from "../../environment";
import { useSessionTenantOrigin } from "../../hooks/useSessionTenantOrigin";
import { isAdminViewUrl } from "../../lib/adminViewUrls";
import { lastVisitedLocation } from "../../lib/urls";
import { Backdrop } from "../Backdrop";
import {
  BackPill,
  BackPillChip,
  BackPillIcon,
  traverseBackPast,
} from "../BackPill";
import { Icon } from "../Icon";
import { Text } from "../Text";
import { SettingsSidebar } from "./SettingsSidebar";

const Content = styled("div")`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
`;

type Props = {
  children: React.ReactNode;
};

export function SettingsLayout({ children }: Props) {
  const from = lastVisitedLocation(
    (url) => !url.startsWith("/settings") && !isAdminViewUrl(url)
  );
  const appOrigin = useSessionTenantOrigin();
  const appHost = (() => {
    try {
      return new URL(appOrigin).hostname;
    } catch {
      return appOrigin;
    }
  })();

  return (
    <>
      <title>{`Settings • ${config.title}`}</title>
      <Backdrop
        permanentNavigation
        navigation={<SettingsSidebar />}
        headerContent={
          <BackPill
            aria-label="Back from Settings"
            to={from ?? "/"}
            onMouseDown={(event) =>
              traverseBackPast(
                event,
                ({ pathname, search, hash }) =>
                  pathname.startsWith("/settings") ||
                  isAdminViewUrl(`${pathname}${search}${hash}`)
              )
            }
          >
            <BackPillIcon />
            <Text>Settings</Text>
            <BackPillChip>
              <Icon name="building-2" size={10} style={{ flexShrink: 0 }} />
              <Text variant="text-small-md" ellipsis>
                {appHost}
              </Text>
            </BackPillChip>
          </BackPill>
        }
      >
        <Content>{children}</Content>
      </Backdrop>
    </>
  );
}
